/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_id: z.string().uuid(),
  construction_plan_area_id: z.string().uuid(),
  work_detail_id: z.number(),
  completed_at: z.number().nullable(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ProcessExecutionBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ProcessExecutionBase = z.infer<typeof base>;
export type ProcessExecutionBasePutPayload = z.infer<typeof put>;
export type ProcessExecutionBasePatchPayload = z.infer<typeof patch>;
export type ProcessExecutionBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ProcessExecutionBaseCreateAttributes = z.infer<typeof create>;
export type ProcessExecutionBaseUpdateAttributes = z.infer<typeof update>;
export type ProcessExecutionBaseCacheAttributes = z.infer<typeof cache>;
export type ProcessExecutionBaseCachesAttributes = z.infer<typeof caches>;